import React from 'react'
/* import Link from 'gatsby-link' */
import Avatar from '../../images/avatar.jpg'
import Computer from '../../images/computer.jpg'
import Trinity from '../../images/trinity-2x.jpg'
import ProjectCard from '../ProjectCard'





class ProjectsGrid extends React.Component {

  state = {
    projects: [
      { id: 'Qi',
        name: 'Qi Statistics',
        url: 'https://www.qistatistics.co.uk'
      },
      { id: 'Sophie',
        name: 'Sophie Doula',
        url: 'https://www.sophiedoula.com'
      },
      { id: 'Envirohive',
        name: 'Envirohive',
        url: 'https://www.envirohive.co.uk/'
      },
      { id: 'Trinity',
        name: 'Trinity',
        url: 'http://www.trinityrock.com'
      },
      { id: 'Garnet',
        name: 'Garnet',
        url: 'https://www.garneteducation.com'
      },
      { id: 'eLM',
        name: 'eLearning Marketplace',
        url: 'https://www.elearningmarketplace.co.uk'
      }

    ]

    
  }

  

  render() {

    return (
      <div className="project-grid">
        {this.state.projects.map( (project) => (
          <ProjectCard key={project.name} name={project.name} id={project.id} link={project.url} />
        ))}
      </div>
    )

  }

}

export default ProjectsGrid



// WEBPACK FOOTER //
// ./src/components/Projects-grid/index.js